export enum SymbolType {
  LINE = 'Line',
  SYMBOL = 'Symbol',
  UNKNOWN = 'Unknown', // FIXME: only needed because of conversion between old and new type
}

export const fromOldSymbolType = (oldType: string) => {
  switch (oldType) {
    case 'Line Types':
      return SymbolType.LINE;
    case 'Symbols':
      return SymbolType.SYMBOL;
    default:
      return SymbolType.UNKNOWN;
  }
};

export const toOldSymbolType = (oldType: string) => {
  switch (oldType) {
    case SymbolType.LINE:
      return 'Line Types';
    case SymbolType.SYMBOL:
      return 'Symbols';
    default:
      return '';
  }
};
